import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getLatestMessage } from "redux-flash";
import { Field, reduxForm } from "redux-form";
import { TextField, Select } from "redux-form-material-ui";
import { MenuItem } from "material-ui/Menu";
import Button from "material-ui/Button";
import { CircularProgress } from "material-ui/Progress";
import { InputLabel } from "material-ui/Input";

import CenteredForm from "../utils/form/CenteredForm";
import {
  required,
  email,
  companynumber,
  date,
  subdomain,
  phonenumber,
} from "../utils/form/formValidation";
import {
  emailUpdateRequest,
  updateRequest,
  specilityByIdRequest,
} from "./actions";
import styles from "./UserProfile.scss";
import Modal from "../utils/modal/modal";

class UserProfile extends React.Component {
  static propTypes = {
    admin: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      successful: PropTypes.bool.isRequired,
      error: PropTypes.String,
      user: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }),
      subcription: PropTypes.shape({
        accountStatus: PropTypes.shape({
          isTrialExpired: PropTypes.bool,
          isCardAdded: PropTypes.bool,
          isSubscriptionExpired: PropTypes.bool,
          remaningTrialDays: PropTypes.number,
          stripeCurrentPeriodEnd: PropTypes.string,
        }),
      }),
    }).isRequired,
    login: PropTypes.shape({
      authData: PropTypes.shape({
        id: PropTypes.string.isRequired,
        userId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    initialize: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    updateRequest: PropTypes.func.isRequired,
    emailUpdateRequest: PropTypes.func.isRequired,
    specilityByIdRequest: PropTypes.func.isRequired,
    "update-profile": PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      specilitys: PropTypes.string.isRequired,
      emailrequesting: PropTypes.bool.isRequired,
    }).isRequired,

    snackbarMessage: PropTypes.objectOf(PropTypes.any).isRequired,
  };
  constructor() {
    super();
    this.state = {
      date: "",
      domainAlreadyUsed: false,
      autoFocusSubdomainCalled: false,
      editEmail: false,
    };
  }
  componentWillMount() {
    this.props.specilityByIdRequest({ id: this.props.admin.user.specialityId });
  }
  submit = (values) => {
    //alert(JSON.stringify(values),this.props.admin.user.id);
    const { id, userId } = this.props.login.authData;
    this.props.updateRequest({ values, id: id, userId: userId });
  };
  componentDidMount() {
    //   console.log("this.props.signup.specilitys.name",this.props.signup.specilitys.name)
    this.props.initialize({
      email: this.props.admin.user.email,
      firstName: this.props.admin.user.firstName,
      lastName: this.props.admin.user.lastName,
      multiDoctorNames: this.props.admin.user.multiDoctorNames,
      birthdate: this.props.admin.user.birthdate || "",
      companynumber: this.props.admin.user.companynumber || "",
      companyname: this.props.admin.user.companyname || "",
      subdomainText: this.modifiySubdomain(
        this.props.admin.user.subdomain || ""
      ),
      postaladdress: this.props.admin.user.postaladdress || "",
      phonenumber: this.props.admin.user.phonenumber || "",
      appointmenturl: this.props.admin.user.appointmenturl || "",
      otherurl: this.props.admin.user.otherurl || "",
    });
  }
  handleEditEmail() {
    if (!this.state.editEmail) {
      if (confirm("Etes-vous sûr de vouloir modifier votre adresse ?")) {
        this.setState({
          editEmail: !this.state.editEmail,
        });
      }
    } else {
      this.setState({
        editEmail: !this.state.editEmail,
      });
    }
  }
  handleUpdateEmail() {
    if (this.refs.email.value == this.props.admin.user.email) {
      this.setState({
        editEmail: !this.state.editEmail,
      });
    } else if (
      confirm(
        "Après avoir mis à jour l'adresse e-mail, votre session en cours est détruite. êtes-vous sûr ?"
      )
    ) {
      const { id, userId } = this.props.login.authData;
      this.props.emailUpdateRequest({
        email: this.refs.email.value,
        id: id,
        userId: userId,
      });
    }
  }

  render() {
    const {
      "update-profile": { error, requesting, emailrequesting, specilitys },
    } = this.props;
    const { handleSubmit, snackbarMessage } = this.props;

    const phoneFormatter = (value) => {
      if (!value) return "";
      var number = value.replace(/[^\d]/g, "");
      if (!number) return "";

      const splitter = /.{1,2}/g;
      number = number.substring(0, 10);
      return (
        number.substring(0, 10).match(splitter).join("-") + number.substring(10)
      );
    };

    const phoneParser = (number) => (number ? number.replace(/-/g, "") : "");

    return (
      <div className={styles.container}>
        <CenteredForm
          title=""
          handleOnSubmit={handleSubmit(this.submit)}
          snackbarMessage={snackbarMessage}
          style={{
            height: "auto",
            position: "inherit",
            top: "0",
            left: "0",
            transform: "inherit",
          }}
        >
          <label className="mb6">
            <h3>Mes coordonnées</h3>
          </label>
          <div className={styles.signupBox}>
            <div className="mb2">
              <Field
                name="email"
                // placeholder="Email"
                label="Mon adresse email"
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                  disabled: !this.state.editEmail,
                }}
                component={TextField}
                validate={[required, email]}
                fullWidth
                withRef
                ref="email"
              />
              <p className="custom-error-message">
                {!!error ? error.email : ""}
              </p>
            </div>
          </div>
          {!this.state.editEmail && (
            <Button
              onClick={() => this.handleEditEmail()}
              className="mb6"
              variant="raised"
              color="primary"
              fullWidth
            >
              Modifier mon adresse email
            </Button>
          )}
          {this.state.editEmail && (
            <div>
              {/* <Button className="mr1 mb1 pull-left"
      onClick={() => this.handleEditEmail()}
      className="mb6"
      variant="raised"
      color="primary"
      >
     Annuler
   </Button> */}
              <Button
                className="mr1 mb1"
                onClick={() => this.handleUpdateEmail()}
                className="mb6"
                fullWidth
                variant="raised"
                color="primary"
              >
                {!emailrequesting && "mettre à jour l'email"}
                {emailrequesting && (
                  <CircularProgress className={styles.requesting} />
                )}
              </Button>
            </div>
          )}
          <Button
            className="mb6"
            variant="raised"
            color="secondary"
            href="/password-change"
            fullWidth
          >
            Changer le mot de passe
          </Button>
          <label className="mb6">
            <h3>Informations sur vous et votre entreprise</h3>
          </label>
          <div className={styles.signupBox}>
            <div className="mb2">
              <InputLabel htmlFor="model">Spécialité Médicale</InputLabel>
              <Field
                name="speciality"
                component={TextField}
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                  readOnly: true,
                  value: specilitys,
                }}
                disabled
                fullWidth
                ref="speciality"
              ></Field>
            </div>
            {!this.props.admin.user.multiDoctor && (
              <div>
                <div className="mb2">
                  <Field
                    name="firstName"
                    placeholder="Prénom"
                    label="Prénom"
                    inputProps={{
                      autoCorrect: "off",
                      autoCapitalize: "none",
                    }}
                    component={TextField}
                    validate={[required]}
                    fullWidth
                    withRef
                    ref="firstName"
                  />
                  <p className="custom-error-message">
                    {!!error ? error.firstName : ""}
                  </p>
                </div>
                <div className="mb2">
                  <Field
                    name="lastName"
                    placeholder="Nom"
                    label="Nom"
                    inputProps={{
                      autoCorrect: "off",
                      autoCapitalize: "none",
                    }}
                    component={TextField}
                    validate={[required]}
                    fullWidth
                    withRef
                    ref="lastName"
                  />
                  <p className="custom-error-message">
                    {!!error ? error.lastName : ""}
                  </p>
                </div>
              </div>
            )}
            {this.props.admin.user.multiDoctor && (
              <div>
                <div className="mb2">
                  <Field
                    name="multiDoctorNames"
                    placeholder="ex: Pierre Dupuis et Jean Dupont"
                    label="Nom des médecins du cabinet"
                    inputProps={{
                      autoCorrect: "off",
                      autoCapitalize: "none",
                    }}
                    component={TextField}
                    validate={[required]}
                    fullWidth
                    withRef
                    ref="multiDoctorNames"
                  />
                  <p className="custom-error-message">
                    {!!error ? error.multiDoctorNames : ""}
                  </p>
                </div>
              </div>
            )}
            <div className="mb2">
              <Field
                name="postaladdress"
                placeholder="Adresse"
                label="Adresse"
                component={TextField}
                fullWidth
                withRef
                ref="adresse"
              />
              <p className="custom-error-message">
                {!!error ? error.address : ""}
              </p>
            </div>
            <div className="mb2">
              <Field
                name="phonenumber"
                placeholder="Téléphone"
                label="Téléphone"
                component={TextField}
                fullWidth
                withRef
                ref="phone"
                validate={[phonenumber]}
                format={phoneFormatter}
                parse={phoneParser}
              />
              <p className="custom-error-message">
                {!!error ? error.phone : ""}
              </p>
            </div>
            <div className="mb2" style={{}}>
              <Field
                name="birthdate"
                placeholder="JJ/MM/AAAA"
                label="Date de naissance"
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                }}
                validate={[date]}
                component={TextField}
                normalize={(value) => {
                  if (
                    /(^\d{0,2}$)|(^\d{2}\/$)|(^\d{2}\/\d{0,2}$)|(^\d{2}\/\d{2}\/\d{0,4}$)/.test(
                      value
                    )
                  ) {
                    return value;
                  } else {
                    return value.slice(0, value.length - 1);
                  }
                }}
                fullWidth
                withRef
                ref="birthdate"
              />
              <p className="custom-error-message">
                {!!error ? error.birthdate : ""}
              </p>
            </div>
            <div className="mb2">
              <Field
                name="companynumber"
                placeholder="SIRET"
                label="SIRET"
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                }}
                component={TextField}
                validate={[companynumber]}
                normalize={(value) => {
                  if (/([\d]$)/.test(value)) {
                    return value;
                  } else {
                    return value.slice(0, value.length - 1);
                  }
                }}
                fullWidth
                withRef
                ref="companynumber"
              />
              <p className="custom-error-message">
                {!!error ? error.companynumber : ""}
              </p>
            </div>
            <div className="mb2">
              <Field
                name="companyname"
                placeholder="Raison sociale"
                label="Raison sociale"
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                }}
                component={TextField}
                fullWidth
                withRef
                ref="companyname"
              />
              <p className="custom-error-message">
                {!!error ? error.companyname : ""}
              </p>
            </div>
            <div className="mb2">
              <Field
                name="otherurl"
                placeholder="Lien vers votre site web"
                label="Lien vers votre site web"
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                }}
                component={TextField}
                fullWidth
                withRef
                ref="otherurl"
              />
              <p className="custom-error-message">
                {!!error ? error.otherurl : ""}
              </p>
            </div>
            <div className="mb2">
              <Field
                name="appointmenturl"
                placeholder="Lien vers votre service de réservation en ligne"
                label="Lien vers votre service de réservation en ligne"
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                }}
                component={TextField}
                fullWidth
                withRef
                ref="appointmenturl"
              />
              <p className="custom-error-message">
                {!!error ? error.appointmenturl : ""}
              </p>
            </div>
            {/* 
   <div className="mb9">
      <Calendar dateFormat="dd/mm/yy" value={this.state.date} 
         onChange={(e) => this.setState({date: e.value})}></Calendar>
   </div>
   */}
            <div className="mb2">
              <Field
                name="subdomainText"
                placeholder="nom-du-médecin"
                label="Sous-domaine"
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                  className: "text-align-start",
                  readOnly: true,
                }}
                disabled="true"
                component={TextField}
                style={{ width: "60%" }}
              />
            </div>
          </div>

          <Button
            className="mb6"
            variant="raised"
            color="primary"
            type={requesting ? "" : "submit"}
            fullWidth
          >
            {!requesting && "mettre à jour"}
            {requesting && <CircularProgress className={styles.requesting} />}
          </Button>
        </CenteredForm>
      </div>
    );
  }
  subDomainFocus() {
    if (!this.state.autoFocusSubdomainCalled) {
      this.state.autoFocusSubdomainCalled = true;
      this.props.initialize({
        email: this.refs.email.value,
        password: this.refs.password.value,
        specialityId: this.refs.speciality.value,
        firstName: this.refs.firstName.value,
        lastName: this.refs.lastName.value,
        multiDoctorNames: this.refs.multiDoctorNames.value,
        birthdate: this.refs.birthdate.value,
        companynumber: this.refs.companynumber.value,
        companyname: this.refs.companyname.value,
        subdomainText: this.modifiySubdomain(this.refs.companyname.value || ""),
      });
    }
  }
  modifiySubdomain(value) {
    let str = value.toLowerCase();
    str = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ /g, "");
    return str;
  }
  isDomainAlreadyUsed(error) {
    if (!!error && error.subdomain && error.subdomain.length) {
      return true;
    }
    return false;
  }
  openModal() {
    this.setState({ isModalOpen: true });
  }
  closeModal(error) {
    if (!!error && error.subdomain) {
      error.subdomain.length = 0;
    }
    this.setState({ isModalOpen: false });
  }
}
const mapStateToProps = (state) => ({
  "update-profile": state["update-profile"],
  login: state.login,
  admin: state.admin,
  snackbarMessage: getLatestMessage(state) || {},
});
const ConnectedUpdate = connect(mapStateToProps, {
  updateRequest,
  emailUpdateRequest,
  specilityByIdRequest,
})(UserProfile);

export default reduxForm({
  form: "userprofile",
})(ConnectedUpdate);



// WEBPACK FOOTER //
// ./src/pages/userprofile/UserProfile.jsx